import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'

import { sum } from 'lib/array/arrayUtils'
import { pluralizeToString } from 'lib/string/pluralize'
import type { Moment } from 'moment'
import moment from 'moment'

export function formatDate(date?: string | Moment, format: string = DMY_CASUAL_FORMAT) {
  return date ? moment(date).format(format) : undefined
}

export function getOccupancyDescription(
  occupancies: Array<App.Occupants>,
  includeOccupancyCount: boolean = true,
  saleUnit: string = 'room',
): string {
  const hasChildren = occupancies.some(occ => occ.childrenAge?.length)
  const occupancyCount = sum(occupancies, occ => occ.adults + (occ.childrenAge?.length ?? 0))

  // TODO - i18n: string concatenation
  let description = `${pluralizeToString(hasChildren ? 'guest' : 'adult', occupancyCount)}`
  if (includeOccupancyCount) description += ` (${pluralizeToString(saleUnit, occupancies.length)})`
  return description
}
